export const IS_MICRO_GENRE_PAYWALL_ENABLED = false;
